/**
 * Search Endpoints
 */

import PATHS from 'src/router/paths'

const endpoints = {
  [PATHS.DASHBOARD.BASE]: {
    altCode: 'networkCode',
    code: 'billingCode',
    error: false,
    filter: false,
    href: `/${PATHS.DASHBOARD.BASE}`,
    items: [],
    name: 'Dashboard',
    recent: [],
    associationId: 'billingCode',
    baseReportName: null,
    results: [],
    routeName: PATHS.DASHBOARD.BASE,
    savedAs: PATHS.DASHBOARD.BASE,
    sub: {
      code: 'teamCode',
      id: 'teamId',
      savedAs: 'team',
      text: (item) => item.teamName,
    },
    text: (item) => item.orgName,
  },
  [PATHS.DELIVERY.PACING]: {
    altCode: 'networkCode',
    code: 'billingCode',
    error: false,
    filter: (item) => item.hasPacing,
    href: `/${PATHS.DELIVERY.BASE}/${PATHS.DELIVERY.PACING}`,
    items: [],
    name: 'Pacing',
    recent: [],
    associationId: 'billingCode',
    baseReportName: PATHS.DELIVERY.PACING,
    results: [],
    routeName: PATHS.DELIVERY.BASE,
    savedAs: PATHS.DELIVERY.PACING,
    sub: {
      code: 'teamCode',
      id: 'teamId',
      savedAs: 'team',
      text: (item) => item.teamName,
    },
    text: (item) => item.name,
  },
  [PATHS.DELIVERY.DISCREPANCY]: {
    altCode: 'networkCode',
    code: 'billingCode',
    error: false,
    filter: (item) => item.hasDiscrepancy,
    href: `/${PATHS.DELIVERY.BASE}/${PATHS.DELIVERY.DISCREPANCY}`,
    items: [],
    name: 'Discrepancy',
    recent: [],
    associationId: 'billingCode',
    baseReportName: PATHS.DELIVERY.DISCREPANCY,
    results: [],
    routeName: PATHS.DELIVERY.BASE,
    savedAs: PATHS.DELIVERY.DISCREPANCY,
    sub: {
      code: 'teamCode',
      id: 'teamId',
      savedAs: 'team',
      text: (item) => item.teamName,
    },
    text: (item) => item.name,
  },
  [PATHS.PROGRAMMATIC.NETWORK_HEALTH]: {
    altCode: 'networkCode',
    code: 'billingCode',
    error: false,
    filter: (item) => item.hasHealthNetwork,
    href: `/${PATHS.PROGRAMMATIC.BASE}/${PATHS.PROGRAMMATIC.NETWORK_HEALTH}`,
    name: 'Network Health',
    items: [],
    recent: [],
    associationId: 'billingCode',
    baseReportName: PATHS.PROGRAMMATIC.NETWORK_HEALTH,
    results: [],
    routeName: PATHS.PROGRAMMATIC.BASE,
    savedAs: PATHS.PROGRAMMATIC.NETWORK_HEALTH,
    subId: 'subId',
    text: (item) => item.name,
  },
  [PATHS.PROGRAMMATIC.ADX_HEALTH]: {
    altCode: 'networkCode',
    code: 'billingCode',
    error: false,
    filter: (item) => item.hasHealthAdx,
    href: `/${PATHS.PROGRAMMATIC.BASE}/${PATHS.PROGRAMMATIC.ADX_HEALTH}`,
    items: [],
    name: 'AdX Health',
    recent: [],
    associationId: 'billingCode',
    baseReportName: PATHS.PROGRAMMATIC.ADX_HEALTH,
    results: [],
    routeName: PATHS.PROGRAMMATIC.BASE,
    savedAs: PATHS.PROGRAMMATIC.ADX_HEALTH,
    subId: 'subId',
    text: (item) => item.name,
  },
  [PATHS.PROGRAMMATIC.ADX_AND_OPEN_BIDDING]: {
    altCode: 'networkCode',
    code: 'billingCode',
    error: false,
    filter: (item) => item.hasYieldPartner,
    href: `/${PATHS.PROGRAMMATIC.BASE}/${PATHS.PROGRAMMATIC.ADX_AND_OPEN_BIDDING}`,
    items: [],
    name: 'AdX & OB',
    recent: [],
    associationId: 'billingCode',
    baseReportName: PATHS.PROGRAMMATIC.ADX_AND_OPEN_BIDDING,
    results: [],
    routeName: PATHS.PROGRAMMATIC.BASE,
    savedAs: PATHS.PROGRAMMATIC.ADX_AND_OPEN_BIDDING,
    subId: 'subId',
    text: (item) => item.name,
  },
  [PATHS.CUSTOM_ANALYTICS.BASE]: {
    altCode: 'networkCode',
    code: 'billingCode',
    error: false,
    filter: false,
    href: '/custom-analytics',
    items: [],
    name: 'Custom Analytics',
    recent: [],
    associationId: 'billingCode',
    baseReportName: PATHS.CUSTOM_ANALYTICS.BASE,
    results: [],
    routeName: PATHS.CUSTOM_ANALYTICS.BASE,
    savedAs: PATHS.CUSTOM_ANALYTICS.BASE,
    subId: 'subId',
    text: (item) => item.name,
  },
  [PATHS.INTERNAL.ORGANIZATION]: {
    altCode: 'networkCode',
    code: 'billingCode',
    error: false,
    items: [],
    href: `/${PATHS.INTERNAL.BASE}/${PATHS.INTERNAL.ORGANIZATION}`,
    name: 'Organization',
    recent: [],
    associationId: 'billingCode',
    baseReportName: PATHS.INTERNAL.ORGANIZATION,
    results: [],
    routeName: PATHS.INTERNAL.BASE,
    savedAs: PATHS.INTERNAL.ORGANIZATION,
    subId: 'subId',
    text: (item) => {
      const isAllAssociation = item.associationId === 'all-associations'
      return isAllAssociation ? 'All Associations' : item.orgName
    },
  },
  [PATHS.INTERNAL.PERSON]: {
    altCode: 'personId',
    code: 'userEmail',
    error: false,
    href: `/${PATHS.INTERNAL.BASE}/${PATHS.INTERNAL.PERSON}`,
    items: [],
    name: 'Person',
    recent: [],
    associationId: 'associationId',
    baseReportName: PATHS.INTERNAL.PERSON,
    results: [],
    routeName: PATHS.INTERNAL.BASE,
    savedAs: PATHS.INTERNAL.PERSON,
    subId: 'subId',
    text: (item) => {
      const isAllAssociation = item.associationId === 'all-associations'
      const isPerson = item.dataType === 'person'
      const personName = () => isPerson && `${item.personNameFirst} ${item.personNameLast}`
      const orgName = () => item.orgName
      return isAllAssociation ? 'All Associations' : personName() || orgName()
    },
  },
  [PATHS.INTERNAL.PROJECT]: {
    altCode: 'projectCode',
    code: 'projectName',
    error: false,
    href: `/${PATHS.INTERNAL.BASE}/${PATHS.INTERNAL.PROJECT}`,
    items: [],
    name: 'Project',
    recent: [],
    associationId: 'associationId',
    baseReportName: PATHS.INTERNAL.PROJECT,
    results: [],
    routeName: PATHS.INTERNAL.BASE,
    savedAs: PATHS.INTERNAL.PROJECT,
    subId: 'subId',
    text: (item) => {
      const isAllAssociation = item.associationId === 'all-associations'
      const isProject = item.dataType === 'project'
      const projectName = () => isProject && item.projectName
      const orgName = () => item.orgName
      return isAllAssociation ? 'All Associations' : projectName() || orgName()
    },
  },
  [PATHS.INTERNAL.TIME_ROLLUP]: {
    altCode: 'timeEntryId',
    code: 'billingCode',
    error: false,
    items: [],
    href: `/${PATHS.INTERNAL.BASE}/${PATHS.INTERNAL.TIME_ROLLUP}`,
    name: 'Rollup',
    recent: [],
    associationId: 'billingCode',
    baseReportName: PATHS.INTERNAL.TIME_ROLLUP,
    results: [],
    routeName: PATHS.INTERNAL.BASE,
    savedAs: PATHS.INTERNAL.TIME_ROLLUP,
    subId: 'subId',
    text: (item) => {
      const isAllAssociation = item.associationId === 'all-associations'
      return isAllAssociation ? 'All Associations' : item.orgName
    },
  },
  [PATHS.INTERNAL.TIME_SHEET]: {
    altCode: 'timeEntryId',
    code: 'billingCode',
    error: false,
    items: [],
    href: `/${PATHS.INTERNAL.BASE}/${PATHS.INTERNAL.TIME_SHEET}`,
    name: 'Time Sheet',
    recent: [],
    associationId: 'billingCode',
    baseReportName: PATHS.INTERNAL.TIME_SHEET,
    results: [],
    routeName: PATHS.INTERNAL.BASE,
    savedAs: PATHS.INTERNAL.TIME_SHEET,
    subId: 'subId',
    text: (item) => `${item.personNameFirst} ${item.personNameLast}`,
  },
  [PATHS.DEVELOP.BASE]: {
    altCode: null,
    code: null,
    error: false,
    filter: false,
    href: `/${PATHS.DEVELOP.BASE}`,
    items: [],
    name: 'Develop',
    recent: [],
    associationId: null,
    baseReportName: PATHS.DEVELOP.BASE,
    results: [],
    routeName: PATHS.DEVELOP.BASE,
    savedAs: false,
    text: () => 'Develop',
  },
}

export default endpoints
